module.exports = __webpack_public_path__ + "img/Circuitdiagram2.01fbfbcd.jpg";